<template>

  <v-snackbar
    v-model="isVisible"
    :bottom="y === 'bottom'"
    :left="x === 'left'"
    :multi-line="mode === 'multi-line'"
    :right="x === 'right'"
    :timeout="timeout"
    :top="y === 'top'"
    :vertical="mode === 'vertical'"
    :color="color"
  >
    <span v-html="text"/>
    <v-btn
      color="white"
      text
      style="background-color:#467fa5 !important"
      @click="isVisible = false"
    >
      Close
    </v-btn>
  </v-snackbar>

</template>

<script>
export default {
    name: "PsToast",

    props: {
        color: {
            type: String,
            required: false,
            default: ""
        },
        mode: {
            type: String,
            required: false,
            default: "multi-line"
        },
        x: {
            type: String,
            required: false,
            default: ""
        },
        y: {
            type: String,
            required: false,
            default: ""
        },
        timeout: {
            type: Number,
            required: false,
            default: 60
        },
        text: {
            type: String,
            required: false,
            default: ""
        },
        value: Boolean
    },
    data () {
        return {};
    },
    computed: {
        isVisible: {
            get () {
                return this.value;
            },
            set (value) {
                this.$emit("input", value);
            }
        }
    },
    mounted () {},
    methods: {}
};
</script>